import CustomerCareNestedLayout from '../customer-care-nested-layout/customer-care-nested-layout'
import MainLayout from '../main-layout/main-layout'
import { CUSTOMER_CARE_LAYOUT } from '../variants'

const CustomerCareLayout = ({ children, nestedLayoutProps, ...props }) => {
	return (
		<MainLayout {...props}>
			<CustomerCareNestedLayout showSidebar={props?.template === CUSTOMER_CARE_LAYOUT} {...nestedLayoutProps}>
				{children}
			</CustomerCareNestedLayout>
		</MainLayout>
	)
}

export default CustomerCareLayout
